/**
 * @file useFormRef
 * @author sunwen05
 */

import {useRef, useImperativeHandle} from 'react';

export default (ref: any) => {
    const formRef = useRef(null);

    const doSubmit = async () => {
        const {doSubmit: handleSubmit} = (formRef.current || {}) as any;
        handleSubmit && await handleSubmit();
    };

    // 关联doSubmit到ref上
    useImperativeHandle(ref, () => ({doSubmit}));

    return {
        formRef
    };
};
